import React from 'react'
import PhoneIndexList from './PhoneIndexList';
import {removeDuplicates,friendElement,committeeList,Breadcrumb,getMandOOffice} from './myFunctions.js';
import { v4 as uuidv4 } from 'uuid'; 
import FriendButtonList from './FriendButtonList';
export default function FriendView({oym,friend,dropBreadcrumb}) {
    let friendObject=oym.objectRef(friend);
    console.log(friendObject);
    let householdObject=oym.objectRef(friendObject.household);
    let meetingObject=oym.objectRef(friendObject.monthlyMeeting);
    let spouseElement=(<></>);
    let spouseObject=null;
    let spouseId=null;
    let mAndOOffice=getMandOOffice(oym,friend); //(<></>);
    // let ministryAndOversightServiceObject=oym.whichministryAndOversightService(friend);
    // console.log("ministryAndOversightServiceObject",ministryAndOversightServiceObject);
    // if (ministryAndOversightServiceObject!=null){
    //     if (ministryAndOversightServiceObject.name==="Ministers"){
    //         mAndOOffice=(<>Minister</>);
    //     } else if (ministryAndOversightServiceObject.name==="Elders"){ 
    //         mAndOOffice=(<>Elder</>);
    //     } else if (ministryAndOversightServiceObject.name==="Overseers"){
    //         mAndOOffice=(<>Overseer</>);
    //     }
    // }
    if (friendObject.spouse!=null){
        spouseObject=oym.objectRef(friendObject.spouse);
        spouseId=spouseObject.id;
        spouseElement=(
            <>
            Spouse:<button onClick={dropFriendViewBreadcrumb}>{spouseObject.name}</button>
            </>
        )
    }
    let phoneNumbers = [];
    if (friendObject.phoneNumber===null){
        if (householdObject!=null&&householdObject.phoneNumbers!=null){
            phoneNumbers = householdObject.phoneNumbers[1];
        }            
    } else {
        phoneNumbers.push(friendObject.phoneNumber)
    }
    let householdAddress="";
    if (householdObject!=null){
        householdAddress=householdObject.address.addressLines;
    }
    let committeesServedOn=[];
    let officesHeld=[];
    let committeesElement=(<></>);
    let officesElement=(<></>);
    const COMMITTEE="Committee";
    const OFFICE="Office";
    console.log(friendObject.serviceTenures[1]);
    if (friendObject.serviceTenures[1]!=null){
        let tenureCommitteesServedOn=friendObject.serviceTenures[1].filter(tenure =>{
            let serviceObject=oym.objectRef(tenure.service);
            console.log(serviceObject.id,serviceObject.id.substr(0,COMMITTEE.length+1))
            return serviceObject.id.substr(0,COMMITTEE.length)===COMMITTEE;
                // console.log("found committee",serviceObject);
                // return serviceObject;
        });
        committeesServedOn=tenureCommitteesServedOn.map(tenure=>{
            return oym.objectRef(tenure.service);
        })
        console.log(committeesServedOn);
        committeesServedOn=removeDuplicates(committeesServedOn);
        if (committeesServedOn.length>0){
            committeesElement=(
                <>
                    Committees:<br/>
                    {/* We pass authenticated={true} because (presently) FriendView is not available to the user unless he/she is autnenticated */}
                    {committeeList(committeesServedOn,oym,dropBreadcrumb,true)}
                </>
            );
        }
        let tenureOfficesHeld=friendObject.serviceTenures[1].filter(tenure =>{
            let serviceObject=oym.objectRef(tenure.service);
            return serviceObject.id.substr(0,OFFICE.length)===OFFICE;
                // officesHeld.push(serviceObject);
        })
        officesHeld=tenureOfficesHeld.map(tenure=>{
            return oym.objectRef(tenure.service);
        })
        console.log(officesHeld);
        if (officesHeld.length>0){
            officesElement=(
                <div>
                    Offices:<br/>
                    {/* We pass authenticated={true} because (presently) FriendView is not available to the user unless he/she is autnenticated */}
                    {committeeList(officesHeld,oym,dropBreadcrumb,true)}
                </div>
            )
        }
    }
    let househouldMembersElement=(<></>);
    if (householdObject!==null&&householdObject.members[1].length>1){
        let householdMembers=householdObject.members[1].filter(member=>{
            let memberObject=oym.objectRef(member);
            return memberObject.id!==friendObject.id&&memberObject.id!==spouseId;
        });
        if (householdMembers.length>0){
            househouldMembersElement=(
                <>
                {/* We pass authenticated={true} because (presently) FriendView is not available to the user unless he/she is autnenticated */}
                    Other members of household: <FriendButtonList list={householdMembers} oym = {oym} dropBreadcrumb={dropBreadcrumb} authenticated={true}/>
                </>
            );    
        }
    }
    let emailsElement=(<></>);
    if(householdObject!==null&&householdObject.emailAddresses[1].length>1){
        console.log(householdObject);
        let emailString="";
        householdObject.emailAddresses[1].forEach(email => {
            emailString+=email;
            emailString+=", ";
        });
        emailString=emailString.substring(0,emailString.length-2);
        emailsElement=(<>Household emails: {emailString}</>)
    }
    let meetingElement=(<></>);
    if (meetingObject!=null){
        console.log(friendObject.name,meetingObject);
        meetingElement=(<>{friendObject.status} member of {meetingObject.name}</>)
    }
    function dropFriendViewBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb(spouseObject.firstName,friendElement(oym,spouseObject,dropBreadcrumb)));
    }
    return (
        <div>
            {friendObject.name}<br/>
            {mAndOOffice}<br></br>
            {meetingElement}<br/>
            Address: {householdAddress}<br/>
            Phone: <PhoneIndexList oym={oym} list = {phoneNumbers} /><br/>
            Primary Email: {friendObject.emailAddress}<br/>
            {emailsElement}<br/>
            {spouseElement}
            <p>{househouldMembersElement}</p>
            {committeesElement}
            {officesElement}
        </div>
    )
}
